<template>
  <div class="qrcode-page" :class="[`qrcode-page--${websocketStatus.state}`, { 'qrcode-page--offline': websocketStatus.state !== 'success', 'qrcode-page--blocked': ipBlocked }]">
    <div v-if="ipBlocked" class="error-container">
      <div class="error-card">
        <div class="error-icon">
          <i class="el-icon-lock"></i>
        </div>
        <div class="error-content">
          <h3>访问受限</h3>
          <p>{{ accessDeniedMessage }}</p>
          <p>如有疑问，请联系培训管理员。</p>
        </div>
      </div>
    </div>
    <div v-else-if="error&&!loading" class="error-container">
    <div class="error-card">
      <div class="error-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <div class="error-content">
        <h3>系统异常</h3>
        <p>{{ errorMessage || '抱歉，系统开小差了，请稍后重试' }}</p>
      </div>
    </div>
  </div>
    <div v-else-if="loading" class="loading-box">
      <van-loading color="#0094ff" type="spinner" size="35px" vertical>加载中...</van-loading>
    </div>

    <!-- 认证弹窗 -->
    <div v-if="!ipBlocked && showAuthDialog" class="auth-overlay">
      <div class="auth-dialog">
        <div class="auth-header-bar">
          <div class="auth-icon">
            <van-icon name="user-o" size="48" />
          </div>
          <div class="auth-header">
            <h3>身份验证</h3>
            <p>请填写以下信息进行验证</p>
          </div>
        </div>
        <div class="auth-scroll-area">
          <van-form ref="authFormRef" @submit="submitAuth" class="auth-form">
            <van-field
              v-model="authName"
              name="authName"
              label="姓名"
              placeholder="请输入姓名"
              :rules="[{ required: true, message: '请输入姓名' }]"
              class="auth-field"
              clearable
            />
            <van-field
              v-model="authPhone"
              name="authPhone"
              label="手机号"
              placeholder="请输入手机号"
              :rules="[
                { required: true, message: '请输入手机号' },
                { validator: checkPhone, message: '手机号格式不正确' }
              ]"
              class="auth-field"
              clearable
            />
          </van-form>
        </div>
        <div class="auth-footer">
          <van-button
            type="primary"
            size="large"
            native-type="submit"
            :loading="authLoading"
            class="auth-submit-btn"
            @click="handleAuthSubmit"
          >
            确认进入
          </van-button>
        </div>
      </div>
    </div>

    <template v-else-if="!ipBlocked && !showAuthDialog && !error && !loading">
      <WatermarkOverlay v-if="showWatermark || authPassed" :text="watermarkText || `${authName}_${authPhone}`" />
      <OnlinePersonnel
        v-if="isAuthorized"
        :visible="showOnlinePersonnel"
        :users="onlinePersonnelList"
        @toggle="showOnlinePersonnel = !showOnlinePersonnel"
      />
      <guide-steps-dialog
        :visible="showGuide"
        @close="showGuide = false"
        @acknowledge="onGuideFinish"
      />
      <header class="qrcode-header">
        <div class="title-block">
          <h2 class="title">{{ details.pxTitle }}</h2>
          <template v-if="useDoubleCode && signTimeRangeMinutes">
            <div class="subtitle-group subtitle-group--dual">
              <span class="subtitle subtitle--strong subtitle--dual-full">签到：{{ signInRangeText }}</span>
              <span class="subtitle subtitle--strong subtitle--dual-full">签退：{{ signOutRangeText }}</span>
              <span class="subtitle subtitle--strong subtitle--dual-compact">签到 {{ signInRangeText }} | 签退 {{ signOutRangeText }}</span>
            </div>
          </template>
          <p class="subtitle" v-if="!useDoubleCode">时间：{{ details.pxTimeStr }}</p>
          <p class="subtitle">地址：{{ details.pxAddres }}</p>
        </div>
        <div class="stats-container">
          <div class="stat-item online-indicator">
            <span class="dot" :class="{ active: onlineCount > 0 }"></span>
            <span class="label">当前在线：</span>
            <span class="count">{{ onlineCount }}</span>
            <span class="unit">人</span>
          </div>
          <!-- <div class="stat-item people-limit">
            <span class="limit-label">人数上限：</span>
            <span class="limit-value">{{ details.peopleCount || '-' }}</span>
            <span class="unit">人</span>
          </div> -->
          <div class="stat-item online-indicator">
            <span class="dot" :class="{ gctive: details.peopleCount > 0 }"></span>
            <span class="label">人数上限：</span>
            <span class="count">{{  details.peopleCount || '-' }}</span>
            <span class="unit">人</span>
          </div>
        </div>
      </header>

      <van-notice-bar
        v-if="noticeVisible"
        class="top-notice"
        :text="noticeText"
        left-icon="volume-o"
        mode="closeable"
        @close="noticeVisible = false"
      />

      <div v-if="showVoiceEnable" class="voice-enable-bar">
        <van-button
          size="small"
          :plain="!voiceCountdownEnabled"
          :type="voiceCountdownEnabled ? 'primary' : 'default'"
          icon="volume-o"
          class="voice-enable-button"
          :class="{ 'voice-enable-button--active': voiceCountdownEnabled }"
          :aria-pressed="voiceCountdownEnabled ? 'true' : 'false'"
          @click="toggleVoiceCountdown"
        >
          <span
            class="voice-enable-button__dot"
            :class="{ 'voice-enable-button__dot--active': voiceCountdownEnabled }"
          ></span>
          <span class="voice-enable-button__state">
            语音提醒：{{ voiceCountdownEnabled ? '已开启' : '未开启' }}
          </span>
          <span class="voice-enable-button__action">
            {{ voiceCountdownEnabled ? '点击关闭' : '点击开启' }}
          </span>
        </van-button>
      </div>

      <section v-if="isAuthorized && authPassed && !useDoubleCode" class="security-tip-card">
        <div class="security-tip-track">
          <div class="security-tip-card__text">
            <span class="security-tip-card__desc">一人一码，当前仅限</span>
            <span class="security-tip-card__name">{{ authName || '当前用户' }}</span>
            <span class="security-tip-card__desc">使用，其他人请谨慎扫描，避免封号！！！</span>
          </div>
          <div class="security-tip-card__text security-tip-card__text--clone" aria-hidden="true">
            <span class="security-tip-card__desc">一人一码，当前仅限</span>
            <span class="security-tip-card__name">{{ authName || '当前用户' }}</span>
            <span class="security-tip-card__desc">使用，其他人请谨慎扫描，避免封号！！！</span>
          </div>
        </div>
      </section>
      <section v-if="showDualCodeCards" class="security-tip-card security-tip-card--dual">
        <div class="dual-status-card">
          <div class="dual-status-card__meta">
            <div class="dual-status-card__code" :class="[signInCardClass, signInProgressToneClass]" @mouseenter="handleCardHover($event, 'SIGN_IN')" @mouseleave="handleCardLeave">
              <div v-if="showSignInProgress" class="dual-status-card__progress" :class="signInProgressToneClass">
                <span class="dual-status-card__progress-bar" :style="{ width: `${signInProgressPercent}%` }"></span>
              </div>
              <span v-if="showSignInProgress && signInProgressPercent > 5" class="dual-status-card__progress-gif" :style="{ left: `${signInProgressPercent}%` }"></span>
              <span class="dual-status-card__code-title">
                <span class="dual-status-card__icon">
                  <van-icon :name="signInCardIcon" />
                </span>
                <span>签到码</span>
                <span class="dual-status-card__badge" v-if="signInCount > 0">{{ signInCount }}</span>
              </span>
              <span class="dual-status-card__code-state">{{ signInCardStateText }}</span>
            </div>
            <div class="dual-status-card__code" :class="[signOutCardClass, signOutProgressToneClass]" @mouseenter="handleCardHover($event, 'SIGN_OUT')" @mouseleave="handleCardLeave">
              <div v-if="showSignOutProgress" class="dual-status-card__progress" :class="signOutProgressToneClass">
                <span class="dual-status-card__progress-bar" :style="{ width: `${signOutProgressPercent}%` }"></span>
              </div>
              <span v-if="showSignOutProgress && signOutProgressPercent > 5" class="dual-status-card__progress-gif" :style="{ left: `${signOutProgressPercent}%` }"></span>
              <span class="dual-status-card__code-title">
                <span class="dual-status-card__icon">
                  <van-icon :name="signOutCardIcon" />
                </span>
                <span>签退码</span>
                <span class="dual-status-card__badge" v-if="signOutCount > 0">{{ signOutCount }}</span>
              </span>
              <span class="dual-status-card__code-state">{{ signOutCardStateText }}</span>
            </div>
          </div>
          <div v-if="dualCodeCountdownSeconds !== null" class="dual-status-card__countdown">
            <span class="dual-status-card__countdown-num">{{ dualCodeCountdownText }}</span>
          </div>
        </div>
      </section>

      <!-- 房间通知浮动提示 -->
      <transition name="room-notify-fade">
        <div v-if="roomNotifyVisible" class="room-notify">
          <van-icon name="bell" size="18" />
          <span class="room-notify-text">{{ roomNotifyText }}</span>
        </div>
      </transition>

      <div class="network-float" :class="[`network-float--${websocketStatus.state}`, { 'network-float--offline': websocketStatus.state !== 'success' }]">
        <span class="network-float__dot"></span>
        <span class="network-float__text">{{ websocketStatus.state === 'success' ? '已连接' : '未连接' }}</span>
      </div>

      <!-- <section class="notice-card">
        <h3 class="notice-title">📌 注意</h3>
        <ul class="notice-list">
          <li>保持屏幕常亮</li>
          <li>关注下方消息</li>
        </ul>
      </section> -->

      <section v-if="isAdmin" class="admin-panel">
        <div class="admin-row">
          <van-button size="small" type="warning" @click="clearRoomCache">清除当前房间二维码</van-button>

        </div>
        <div class="admin-row admin-broadcast-row">
          <van-field
            v-model="broadcastInput"
            class="broadcast-input"
            placeholder="输入要广播给本房间所有人的消息"
            clearable
            size="small"
          />
          <van-button size="small" type="primary" @click="sendBroadcast">发送广播</van-button>
        </div>
      </section>
      <div class="qrcode-container">
        <div class="qs-text-display" :class="[
          { 'qs-text-display-red': isSpecialCondition },
          { 'qs-text-display-offline': websocketStatus.state !== 'success' }
        ]">实时消息：{{ websocketStatus.state === 'success' ? qsText : websocketStatus.message }}</div>
      </div>
      <main class="qrcode-content">
        <div class="qrcode-wrapper" :class="{
          'qrcode-wrapper--loading': !imageUrl,
          'qrcode-wrapper--warning': qrValid && qrCountdown <= 5
        }">
          <template v-if="imageUrl">
            <img
              :src="fullImageUrl"
              alt="二维码"
              class="qrcode-image"
            />
          </template>

          <template v-else>
            <div class="qrcode-placeholder">
              <template v-if="!isSpecialCondition">
               <span class="gradient-pulse-text">
                请提前打开扫码框，该区域显示二维码
              </span>

              </template>
              <template v-else>
                <div class="spinner"></div>
              <p class="placeholder-text">正在生成二维码...</p>
              </template>
            </div>
          </template>
        </div>
        <!-- 二维码有效期倒计时提示 -->
        <div v-if="qrCreatedAt" class="qr-countdown-box">
            <template v-if="qrValid">
              <div class="countdown-wrapper" :class="{ 'countdown-warning': qrCountdown <= 5 }">
                <span class="countdown-label">⏱️ 二维码有效期剩余</span>
                <span class="countdown-number" :class="{ 'countdown-critical': qrCountdown <= 5 }">{{qrCountdown}}</span>
                <span class="countdown-unit">秒</span>
              </div>
            </template>
            <template v-else>
              <div class="countdown-expired">
                <span class="expired-icon">⚠️</span>
                <span class="expired-text">二维码已失效，请等待新的二维码</span>
              </div>
            </template>
          </div>
      </main>

      <div
        v-if="showScanLogPopup"
        class="scan-log-popup"
        :style="{
          left: `${popupPosition.x}px`,
          top: `${popupPosition.y}px`,
        }"
        @mouseleave="handlePopupLeave"
      >
        <div class="scan-log-popup__arrow"></div>
        <div class="scan-log-popup__header">
          <span class="scan-log-popup__title">{{ getPopupTitle() }}</span>
          <span class="scan-log-popup__count">共 {{ scanLogList.length }} 条</span>
        </div>
        <div class="scan-log-popup__body">
          <van-loading v-if="scanLogLoading" color="#0094ff" type="spinner" size="20px" vertical>加载中...</van-loading>
          <div v-else-if="scanLogList.length === 0" class="scan-log-popup__empty">
            <span>暂无扫码记录</span>
          </div>
          <div v-else class="scan-log-popup__list">
            <div v-for="(log, index) in scanLogList" :key="log.id || index" class="scan-log-popup__item">
              <span class="scan-log-popup__time">{{ formatScanTime(log.scanTime) }}</span>
              <span class="scan-log-popup__region">{{ formatIpRegion(log.ipRegion) }}</span>
              <span v-if="log.qrRemainingSeconds != null" class="scan-log-popup__remaining">
                剩余{{ log.qrRemainingSeconds }}秒
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div v-if="!ipBlocked && showVoicePrompt" class="voice-prompt-overlay">
      <div class="voice-prompt-dialog">
        <div class="voice-prompt-icon">
          <van-icon name="volume-o" />
        </div>
        <h3 class="voice-prompt-title">开启语音提醒？</h3>
        <p class="voice-prompt-desc">动态二维码倒计时和即将扫码时，可以自动语音提醒，避免错过扫码时机。</p>
        <div class="voice-prompt-actions">
          <van-button plain size="small" class="voice-prompt-cancel" @click="cancelVoicePrompt">暂不开启</van-button>
          <van-button type="primary" size="small" class="voice-prompt-confirm" @click="confirmVoicePrompt">开启提醒</van-button>
        </div>
      </div>
    </div>

    <div v-if="!ipBlocked && !showRoleDialog" class="role-overlay">
      <div class="role-dialog">
        <h3 class="role-title">选择进入方式</h3>
        <p class="role-tip">请选择以游客或管理员身份进入本房间</p>
        <div class="role-actions">
          <van-button type="default" size="small" @click="enterAsGuest">游客进入</van-button>
          <van-button type="primary" size="small" @click="showAdminInput = true">管理员进入</van-button>
        </div>
        <div v-if="showAdminInput" class="admin-input">
          <van-field
            v-model="adminPassword"
            type="password"
            class="password-input"
            placeholder="请输入管理员密码"
            clearable
            size="small"
          />
          <div class="role-actions">
            <van-button type="primary" size="small" @click="confirmAdmin">确认</van-button>
            <van-button size="small" plain @click="cancelAdmin">取消</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Toast, Form, Field, FieldRule, Button,
} from 'vant';
import { getShadRoomInfo, verifyRoomAuth, getScanLogByKeyScrent } from '@/api/index';
import QRCode from 'qrcode';
import { shouldShowGuide } from '@/utils/guide';
import WatermarkOverlay from './WatermarkOverlay.vue';
import GuideStepsDialog from './GuideStepsDialog.vue';
import OnlinePersonnel from './statistics/OnlinePersonnel.vue';

export default {
  name: 'QrcodeView',
  components: { WatermarkOverlay, GuideStepsDialog, OnlinePersonnel },
  data() {
    return {
      AUTH_STORAGE_KEY: 'px_auth_info',
      AUTH_EXPIRE_TIME: 60 * 60 * 1000, // 40分钟
      showGuideDialog: true,
      ws: null,
      isShadowMode: false,
      // wsUrl: 'ws://localhost:8080/web-qrcode',
      wsUrl: process.env.VUE_APP_WS_URL,
      imageUrl: '', // 存储生成的二维码图片 base64 或 data URL
      clientId: '',
      onlineCount: 0,
      showOnlinePersonnel: false,
      onlinePersonnelList: [],
      isAuthorized: false, // 是否需要认证
      reconnectTimer: null,
      details: {},
      reconnectDelay: 3000,
      loading: true,
      error: false,
      errorMessage: '',
      role: '',
      isAdmin: false,
      showRoleDialog: true,
      showAdminInput: false,
      adminPassword: '',
      screenLocked: false,
      broadcastInput: '',
      noticeVisible: false,
      noticeText: '',
      roomNotifyText: '', // 房间通知消息
      roomNotifyVisible: false, // 房间通知显示状态
      qsText: '请等候更新..',
      isSpecialCondition: false, // 添加特殊条件标志
      qrCountdown: null, // 二维码剩余倒计时（秒）
      qrValid: false, // 二维码当前是否有效
      qrCreatedAt: null, // 二维码创建时间戳
      qrTotalDuration: 20, // 二维码有效秒数，可以调整
      qrTimer: null, // 倒计时定时器
      qrUidRaw: '', // 原始二维码数据
      dualCodeNowTs: Date.now(),
      dualCodeClock: null,
      clickCount: 0, // 实时消息区域点击计数
      clickTimer: null, // 点击计数重置计时器
      // 认证相关数据
      showAuthDialog: false, // 显示认证弹窗
      authName: '', // 认证姓名
      authPhone: '', // 认证手机号
      authLoading: false, // 认证提交loading
      authPassed: false, // 认证是否通过
      isRemoved: false, // 是否被移除房间
      visitToken: '', // 当前浏览器标签页访问标识，WebSocket重连时保持不变
      ipBlocked: false,
      accessDeniedMessage: '当前网络已被限制访问培训房间。',

      websocketStatus: {
        ready: false,
        state: 'warn',
        label: '未连接',
        message: '正在建立实时连接',
      },

      websocketTimer: null,
      heartbeatTimer: null,
      lastHeartbeatAt: null,
      lastPongAt: 0,
      lastMessageAt: 0,
      reconnectAttempts: 0,
      maxReconnectAttempts: 10,
      maxReconnectDelay: 30000,
      suppressReconnect: false,
      showWatermark: false,
      watermarkText: '',
      showGuide: false,

      // 扫码次数统计
      signInCount: 0,
      signOutCount: 0,

      // 扫码记录浮窗
      showScanLogPopup: false,
      popupType: '', // 'SIGN_IN' 或 'SIGN_OUT'
      popupPosition: { x: 0, y: 0 },
      scanLogList: [],
      scanLogLoading: false,
      scanLogCache: {},
      voiceCountdownEnabled: false,
      showVoicePrompt: false,
      qrVoiceActive: false,
      qrVoiceIntroDone: false,
      qrVoiceIntroTimer: null,
      hasSpokenCountdownPrefix: false,
      lastVoiceSecond: null,
      lastReadyVoiceAt: 0,
      lastReadyVibrationAt: 0,
    };
  },

  computed: {
    fullImageUrl() {
      if (!this.imageUrl) {
        return '';
      }
      // 如果是 data URL（前端生成的二维码），直接返回
      if (this.imageUrl.startsWith('data:image')) {
        return this.imageUrl;
      }
      // 如果是 http/https URL，直接返回
      if (this.imageUrl.startsWith('http://') || this.imageUrl.startsWith('https://')) {
        return this.imageUrl;
      }
      // 如果是相对路径，添加 /api 前缀（兼容旧逻辑）
      return `/api${this.imageUrl}`;
    },
    showVoiceEnable() {
      return typeof window !== 'undefined'
        && 'speechSynthesis' in window
        && 'SpeechSynthesisUtterance' in window;
    },
    useDoubleCode() {
      return ['Y', '1', 1, true].includes(this.details && this.details.isTwo);
    },
    signTimeRangeMinutes() {
      const timeText = (this.details && this.details.pxTimeStr) || '';
      const dateMatch = timeText.match(/(\d{4}-\d{2}-\d{2})/);
      const matches = timeText.match(/\d{1,2}:\d{2}/g);
      if (!dateMatch || !matches || matches.length < 2) {
        return null;
      }
      const startAt = this.parseDateTime(dateMatch[1], matches[0]);
      const endAt = this.parseDateTime(dateMatch[1], matches[matches.length - 1]);
      if (!startAt || !endAt) {
        return null;
      }
      return {
        trainingDurationMinutes: (endAt.getTime() - startAt.getTime()) / (60 * 1000),
        signInStart: startAt.getTime() - (30 * 60 * 1000),
        signInEnd: startAt.getTime() + (10 * 60 * 1000),
        signOutStart: endAt.getTime() - (20 * 60 * 1000),
        signOutEnd: endAt.getTime(),
      };
    },
    showDualCodeCards() {
      return this.useDoubleCode
        && !!this.signTimeRangeMinutes
        && this.signTimeRangeMinutes.trainingDurationMinutes >= 30;
    },
    signInRangeText() {
      if (!this.signTimeRangeMinutes) return '--';
      return `${this.formatDateTimeMs(this.signTimeRangeMinutes.signInStart)}~${this.formatDateTimeMs(this.signTimeRangeMinutes.signInEnd)}`;
    },
    signOutRangeText() {
      if (!this.signTimeRangeMinutes) return '--';
      return `${this.formatDateTimeMs(this.signTimeRangeMinutes.signOutStart)}~${this.formatDateTimeMs(this.signTimeRangeMinutes.signOutEnd)}`;
    },
    dualCodeStage() {
      if (!this.useDoubleCode || !this.signTimeRangeMinutes) return '';
      const nowTs = this.dualCodeNowTs || Date.now();
      if (nowTs < this.signTimeRangeMinutes.signInStart) return 'beforeSignIn';
      if (nowTs <= this.signTimeRangeMinutes.signInEnd) return 'signIn';
      if (nowTs < this.signTimeRangeMinutes.signOutStart) return 'beforeSignOut';
      if (nowTs <= this.signTimeRangeMinutes.signOutEnd) return 'signOut';
      return 'afterSignOut';
    },
    dualCodeTypeText() {
      if (this.dualCodeStage === 'signOut' || this.dualCodeStage === 'afterSignOut') {
        return '签退码';
      }
      return '签到码';
    },
    signInCardStateText() {
      if (this.dualCodeStage === 'beforeSignIn') return '即将开始';
      if (this.dualCodeStage === 'signIn') return '已开始';
      return '已结束';
    },
    signInCardIcon() {
      if (this.dualCodeStage === 'beforeSignIn') return 'underway-o';
      if (this.dualCodeStage === 'signIn') return 'clock-o';
      return 'passed';
    },
    signOutCardStateText() {
      if (this.dualCodeStage === 'beforeSignOut') return '即将开始';
      if (this.dualCodeStage === 'signOut') return '已开始';
      if (this.dualCodeStage === 'afterSignOut') return '已结束';
      return '未开始';
    },
    signOutCardIcon() {
      if (this.dualCodeStage === 'beforeSignOut') return 'underway-o';
      if (this.dualCodeStage === 'signOut') return 'clock-o';
      return 'passed';
    },
    signInCardClass() {
      return {
        'dual-status-card__code--active': this.dualCodeStage === 'signIn',
        'dual-status-card__code--soon': this.dualCodeStage === 'beforeSignIn',
        'dual-status-card__code--idle': this.dualCodeStage !== 'signIn' && this.dualCodeStage !== 'beforeSignIn',
      };
    },
    signOutCardClass() {
      return {
        'dual-status-card__code--active': this.dualCodeStage === 'signOut',
        'dual-status-card__code--soon': this.dualCodeStage === 'beforeSignOut',
        'dual-status-card__code--idle': this.dualCodeStage !== 'signOut' && this.dualCodeStage !== 'beforeSignOut',
      };
    },
    showSignInProgress() {
      return this.dualCodeStage === 'signIn' && !!this.signTimeRangeMinutes;
    },
    signInProgressPercent() {
      if (!this.showSignInProgress || !this.signTimeRangeMinutes) {
        return 0;
      }
      const total = this.signTimeRangeMinutes.signInEnd - this.signTimeRangeMinutes.signInStart;
      const remaining = this.signTimeRangeMinutes.signInEnd - (this.dualCodeNowTs || Date.now());
      if (total <= 0 || remaining <= 0) {
        return 0;
      }
      return Math.max(0, Math.min(100, (remaining / total) * 100));
    },
    signInProgressToneClass() {
      return this.getProgressToneClass(this.signInProgressPercent, this.showSignInProgress);
    },
    showSignOutProgress() {
      return this.dualCodeStage === 'signOut' && !!this.signTimeRangeMinutes;
    },
    signOutProgressPercent() {
      if (!this.showSignOutProgress || !this.signTimeRangeMinutes) {
        return 0;
      }
      const total = this.signTimeRangeMinutes.signOutEnd - this.signTimeRangeMinutes.signOutStart;
      const remaining = this.signTimeRangeMinutes.signOutEnd - (this.dualCodeNowTs || Date.now());
      if (total <= 0 || remaining <= 0) {
        return 0;
      }
      return Math.max(0, Math.min(100, (remaining / total) * 100));
    },
    signOutProgressToneClass() {
      return this.getProgressToneClass(this.signOutProgressPercent, this.showSignOutProgress);
    },
    dualCodeCountdownLabel() {
      switch (this.dualCodeStage) {
        case 'beforeSignIn':
          return '距离开始签到还有';
        case 'signIn':
          return '已开始签到';
        case 'beforeSignOut':
          return '距离签退还有';
        case 'signOut':
          return '已开始签退';
        default:
          return '签退时间已结束';
      }
    },
    dualCodeCountdownSeconds() {
      if (!this.signTimeRangeMinutes) return null;
      const targetTime = this.dualCodeStage === 'beforeSignIn'
        ? this.signTimeRangeMinutes.signInStart
        : this.dualCodeStage === 'beforeSignOut'
          ? this.signTimeRangeMinutes.signOutStart
          : null;
      if (targetTime === null) return null;
      return Math.max(0, Math.floor((targetTime - (this.dualCodeNowTs || Date.now())) / 1000));
    },
    dualCodeCountdownText() {
      if (this.dualCodeCountdownSeconds === null) return '';
      const total = this.dualCodeCountdownSeconds;
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      if (hours > 0) {
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
  },
  created() {
    this.visitToken = this.getOrCreateVisitToken();
    this.isShadowMode = this.$route && this.$route.query && this.$route.query.shadow === '1';
    const routeClientId = this.$route && this.$route.params && this.$route.params.keyScrent;
    if (routeClientId) {
      this.clientId = routeClientId;
    } else {
      Toast.fail('缺少参数！');
      this.error = true;
      this.loading = false;
      this.errorMessage = '页面缺少必传参数';
      return;
    }
    this.initPage(routeClientId);
  },
  mounted() {
    this.dualCodeClock = setInterval(() => {
      this.dualCodeNowTs = Date.now();
    }, 1000);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleWindowFocus);
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('pageshow', this.handlePageShow);
    this.showVoicePrompt = this.showVoiceEnable;
  },

  beforeDestroy() {
    this.cleanupWebSocket();
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }

    if (this.websocketTimer) {
      clearInterval(this.websocketTimer);
      this.websocketTimer = null;
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
    if (this.dualCodeClock) {
      clearInterval(this.dualCodeClock);
      this.dualCodeClock = null;
    }
    if (this.qrTimer) {
      clearInterval(this.qrTimer);
      this.qrTimer = null;
    }
    this.cancelVoiceCountdown();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('pageshow', this.handlePageShow);
  },

  beforeRouteLeave(to, from, next) {
    // 在路由离开前清理WebSocket连接
    this.cleanupWebSocket();
    // 清除重连定时器，防止页面销毁后重新连接
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.networkTimer) {
      clearInterval(this.networkTimer);
      this.networkTimer = null;
    }
    if (this.websocketTimer) {
      clearInterval(this.websocketTimer);
      this.websocketTimer = null;
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
    if (this.dualCodeClock) {
      clearInterval(this.dualCodeClock);
      this.dualCodeClock = null;
    }
    if (this.qrTimer) {
      clearInterval(this.qrTimer);
      this.qrTimer = null;
    }
    this.cancelVoiceCountdown();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('pageshow', this.handlePageShow);
    next();
  },
  methods: {
    markRealtimeAlive() {
      const now = Date.now();
      this.lastMessageAt = now;
      this.lastPongAt = now;
      this.lastHeartbeatAt = null;
    },
    handleVisibilityChange() {
      if (!document.hidden) {
        this.ensureActiveConnection();
      }
    },
    handleWindowFocus() {
      this.ensureActiveConnection();
    },
    handleOnline() {
      this.ensureActiveConnection();
    },
    handlePageShow() {
      this.ensureActiveConnection();
    },
    ensureActiveConnection() {
      if (this.isRemoved || this.showAuthDialog) {
        return;
      }
      const { ws } = this;
      const now = Date.now();
      const isOpen = !!ws && ws.readyState === WebSocket.OPEN;
      const staleMs = this.lastMessageAt ? now - this.lastMessageAt : Number.MAX_SAFE_INTEGER;
      if (!isOpen || staleMs > 25000) {
        this.scheduleReconnect(true);
      }
    },
    getProgressToneClass(percent, enabled) {
      if (!enabled) {
        return '';
      }
      if (percent <= 33) {
        return 'dual-status-card__code--ending';
      }
      if (percent <= 66) {
        return 'dual-status-card__code--warning';
      }
      return 'dual-status-card__code--healthy';
    },
    parseDateTime(dateText, timeText) {
      const [year, month, day] = String(dateText).split('-').map(Number);
      const [hours, minutes] = String(timeText).split(':').map(Number);
      if ([year, month, day, hours, minutes].some((item) => Number.isNaN(item))) {
        return null;
      }
      return new Date(year, month - 1, day, hours, minutes, 0, 0);
    },
    formatDateTimeMs(timestamp) {
      const date = new Date(timestamp);
      if (Number.isNaN(date.getTime())) {
        return '--';
      }
      const hh = String(date.getHours()).padStart(2, '0');
      const mm = String(date.getMinutes()).padStart(2, '0');
      return `${hh}:${mm}`;
    },
    onGuideFinish() {
      this.showGuide = false;

      // 在这里执行扫码逻辑
      // this.startScan()
    },
    enableVoiceCountdown() {
      if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) {
        Toast.fail('当前浏览器不支持语音提醒');
        return;
      }
      this.voiceCountdownEnabled = true;
      this.showVoicePrompt = false;
      this.speakVoice('语音提醒已开启', true);
    },
    disableVoiceCountdown() {
      this.voiceCountdownEnabled = false;
      this.cancelVoiceCountdown();
      Toast.success('语音提醒已关闭');
    },
    toggleVoiceCountdown() {
      if (this.voiceCountdownEnabled) {
        this.disableVoiceCountdown();
        return;
      }
      this.enableVoiceCountdown();
    },
    confirmVoicePrompt() {
      this.enableVoiceCountdown();
    },
    cancelVoicePrompt() {
      this.showVoicePrompt = false;
    },
    speakVoice(text, force = false, options = {}) {
      if (!text || (!force && !this.voiceCountdownEnabled)) {
        return;
      }
      if (!window.speechSynthesis || !window.SpeechSynthesisUtterance) {
        return;
      }
      try {
        window.speechSynthesis.cancel();
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'zh-CN';
        utterance.rate = this.getVoiceRate(options.rate || 1.6, text, options);
        utterance.pitch = 1;
        utterance.volume = 1;
        if (typeof options.onend === 'function') {
          utterance.onend = options.onend;
        }
        window.speechSynthesis.speak(utterance);
      } catch (e) {
        // 语音播报失败不影响二维码主流程
      }
    },
    isMobileVoiceDevice() {
      if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
      }
      return window.matchMedia('(max-width: 768px)').matches
        || /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
    },
    getVoiceRate(rate, text = '', options = {}) {
      const baseRate = Number(rate) || 1.6;
      if (!this.isMobileVoiceDevice()) {
        return baseRate;
      }
      const contentLength = String(text || '').replace(/\s/g, '').length;
      let mobileRateFactor = options.mobileRateFactor;
      if (!mobileRateFactor) {
        if (contentLength >= 12) {
          mobileRateFactor = 0.58;
        } else if (contentLength >= 8) {
          mobileRateFactor = 0.62;
        } else {
          mobileRateFactor = 0.68;
        }
      }
      return Math.max(1.2, Number((baseRate * mobileRateFactor).toFixed(2)));
    },
    cancelVoiceCountdown() {
      this.qrVoiceActive = false;
      this.qrVoiceIntroDone = false;
      if (this.qrVoiceIntroTimer) {
        clearTimeout(this.qrVoiceIntroTimer);
        this.qrVoiceIntroTimer = null;
      }
      this.hasSpokenCountdownPrefix = false;
      this.lastVoiceSecond = null;
      if (typeof window !== 'undefined' && window.speechSynthesis) {
        window.speechSynthesis.cancel();
      }
    },
    markQrVoiceIntroDone() {
      if (!this.qrVoiceActive || this.qrVoiceIntroDone) {
        return;
      }
      this.qrVoiceIntroDone = true;
      if (this.qrVoiceIntroTimer) {
        clearTimeout(this.qrVoiceIntroTimer);
        this.qrVoiceIntroTimer = null;
      }
      this.handleQrVoiceCountdown(this.qrCountdown);
    },
    startDynamicQrVoice(leftSeconds) {
      this.qrVoiceActive = true;
      this.qrVoiceIntroDone = false;
      if (this.qrVoiceIntroTimer) {
        clearTimeout(this.qrVoiceIntroTimer);
        this.qrVoiceIntroTimer = null;
      }
      this.hasSpokenCountdownPrefix = false;
      this.lastVoiceSecond = null;
      this.speakVoice(`二维码已生成，有效期${leftSeconds}秒`, false, {
        rate: 2.85,
        onend: this.markQrVoiceIntroDone,
      });
      // this.qrVoiceIntroTimer = setTimeout(() => {
      //   this.markQrVoiceIntroDone();
      // }, 2200);
    },
    stopDynamicQrVoice() {
      this.qrVoiceActive = false;
      this.qrVoiceIntroDone = false;
      if (this.qrVoiceIntroTimer) {
        clearTimeout(this.qrVoiceIntroTimer);
        this.qrVoiceIntroTimer = null;
      }
      this.hasSpokenCountdownPrefix = false;
      this.lastVoiceSecond = null;
    },
    handleQrVoiceCountdown(leftSeconds) {
      if (!this.qrVoiceActive || !this.voiceCountdownEnabled) {
        return;
      }
      if (!this.qrVoiceIntroDone || !leftSeconds ||  this.lastVoiceSecond === leftSeconds) {
        return;
      }
      this.lastVoiceSecond = leftSeconds;
      const text = `${leftSeconds}秒`
      this.hasSpokenCountdownPrefix = true;
      let rate=2.55;
      if (leftSeconds>=10){
        rate=3.25;
      }
      this.speakVoice(text, false, { rate: rate });
    },
    speakReadyToScan(message) {
      if (this.qrVoiceActive || (window.speechSynthesis && window.speechSynthesis.speaking)) {
        return;
      }
      const now = Date.now();
      if (now - this.lastReadyVoiceAt < 3000) {
        return;
      }
      this.lastReadyVoiceAt = now;

      const voiceText = String(message || '请打开扫码框，准备扫码')
        .replace(/！/g, '')
        .trim();
      this.speakVoice(voiceText, false, { rate: 2.35, mobileRateFactor: 0.58 });
    },
    vibrateReadyToScan() {
      if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') {
        return;
      }
      const now = Date.now();
      if (now - this.lastReadyVibrationAt < 3000) {
        return;
      }
      this.lastReadyVibrationAt = now;
      try {
        // 两短一长的节奏用于提示即将扫码；不支持震动的浏览器会自动忽略。
        navigator.vibrate([180, 100, 180, 100, 320]);
      } catch (e) {
        // 震动属于增强提醒，调用失败不能影响二维码主流程。
      }
    },
    // 保存认证信息到本地存储
    saveAuthInfo(name, phone) {
      const authInfo = {
        name,
        phone,
        clientId: this.clientId,
        timestamp: Date.now(),
      };
      localStorage.setItem(this.AUTH_STORAGE_KEY, JSON.stringify(authInfo));
    },

    // 获取本地存储的认证信息
    getAuthInfo() {
      try {
        const stored = localStorage.getItem(this.AUTH_STORAGE_KEY);
        if (!stored) return null;

        const authInfo = JSON.parse(stored);
        // 检查是否过期
        if (Date.now() - authInfo.timestamp > this.AUTH_EXPIRE_TIME) {
          this.clearAuthInfo();
          return null;
        }
        // 检查是否是同一个房间
        if (authInfo.clientId !== this.clientId) {
          this.clearAuthInfo();
          return null;
        }
        return authInfo;
      } catch (e) {
        this.clearAuthInfo();
        return null;
      }
    },

    // 清除认证信息
    clearAuthInfo() {
      localStorage.removeItem(this.AUTH_STORAGE_KEY);
    },

    checkPhone(val) {
      return /^1[3-9]\d{9}$/.test(val);
    },
    formatTime(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '--';
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    handleNetworkStatusChange(status) {
      this.networkStatus = status || this.networkStatus;
    },
    stopNetworkCheck() {
      if (this.networkTimer) {
        clearInterval(this.networkTimer);
        this.networkTimer = null;
      }
    },
    startWebSocketHealthCheck() {
      this.stopWebSocketHealthCheck();
      this.websocketTimer = setInterval(() => {
        const { ws } = this;
        const now = Date.now();
        const open = !!ws && ws.readyState === WebSocket.OPEN;
        const connecting = !!ws && ws.readyState === WebSocket.CONNECTING;
        const closed = !ws || ws.readyState === WebSocket.CLOSED || ws.readyState === WebSocket.CLOSING;
        const staleMs = this.lastMessageAt ? now - this.lastMessageAt : Number.MAX_SAFE_INTEGER;
        if (open) {
          if (staleMs > 25000) {
            this.websocketStatus = {
              ready: false,
              state: 'warn',
              label: '恢复中',
              message: '实时通道无响应，正在尝试恢复',
            };
            this.scheduleReconnect(true);
            return;
          }
          this.websocketStatus = {
            ready: true,
            state: 'success',
            label: '已连接',
            message: '实时通道已就绪，数据同步中',
          };
          return;
        }
        if (connecting) {
          this.websocketStatus = {
            ready: false,
            state: 'warn',
            label: '连接中',
            message: '实时通道连接中，请稍候',
          };
          return;
        }
        if (closed) {
          this.websocketStatus = {
            ready: false,
            state: 'danger',
            label: '未连接',
            message: '实时通道已断开，正在恢复连接',
          };
        }
      }, 2000);
    },
    stopWebSocketHealthCheck() {
      if (this.websocketTimer) {
        clearInterval(this.websocketTimer);
        this.websocketTimer = null;
      }
    },
    startHeartbeat() {
      this.stopHeartbeat();
      this.heartbeatTimer = setInterval(() => {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
        try {
          this.lastHeartbeatAt = Date.now();
          this.ws.send(JSON.stringify({ type: 'ping', time: this.lastHeartbeatAt }));
        } catch (e) {
          this.websocketStatus = {
            ready: false,
            state: 'danger',
            label: '异常',
            message: '实时通道已中断，正在尝试恢复',
          };
          this.scheduleReconnect(false);
        }
      }, 10000);
    },
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },

    async initPage(keyScrent) {
      const ok = await this.getPxInfo(keyScrent);
      if (!ok) {
        return;
      }
      this.showGuide = shouldShowGuide() && this.details.introScreenPage === 'Y';
      this.startWebSocketHealthCheck();
      this.startHeartbeat();
    },
    connectWebSocket(isAuthorized) {
      if (this.ipBlocked) {
        return;
      }
      this.suppressReconnect = true;
      this.cleanupWebSocket();
      this.suppressReconnect = false;

      try {
        let url = this.wsUrl;
        if (this.clientId) {
          const param = `clientId=${encodeURIComponent(this.clientId)}`;
          let param2 = `isAuthor=${isAuthorized}`;
          if (this.isShadowMode) {
            param2 += '&shadow=1';
          }
          if (isAuthorized) {
            const authInfo = this.getAuthInfo();
            if (authInfo) {
              const name = encodeURIComponent(authInfo.name);
              const phone = encodeURIComponent(authInfo.phone);
              param2 = `isAuthor=${isAuthorized}&name=${name}&phone=${phone}`;
              if (this.isShadowMode) {
                param2 += '&shadow=1';
              }
            }
          }
          const visitParam = `visitToken=${encodeURIComponent(this.visitToken || this.getOrCreateVisitToken())}`;
          url = `${url}?${param}&${param2}&${visitParam}`;
        }
        this.ws = new WebSocket(url);

        this.ws.onopen = () => {
          this.reconnectAttempts = 0;
          this.markRealtimeAlive();
          this.websocketStatus = {
            ready: true,
            state: 'success',
            label: '已连接',
            message: '实时通道已就绪，数据同步中',
          };
        };

        this.ws.onmessage = (event) => {
          if (typeof event.data === 'string' && event.data === 'pong') {
            this.markRealtimeAlive();
            return;
          }
          this.markRealtimeAlive();
          this.handleMessage(event.data);
        };

        this.ws.onerror = () => {
          this.websocketStatus = {
            ready: false,
            state: 'danger',
            label: '异常',
            message: '实时通道异常，正在自动恢复',
          };
          this.scheduleReconnect();
        };

        this.ws.onclose = () => {
          this.websocketStatus = {
            ready: false,
            state: 'danger',
            label: '已断开',
            message: '实时通道已断开，正在恢复连接',
          };
          if (!this.isRemoved && !this.suppressReconnect) {
            this.scheduleReconnect(false);
          }
        };
      } catch (e) {
        this.websocketStatus = {
          ready: false,
          state: 'danger',
          label: '异常',
          message: '实时通道已中断，正在尝试恢复',
        };
        this.scheduleReconnect(false);
      }
    },
    enterAsGuest() {
      this.role = 'guest';
      this.isAdmin = false;
      this.showRoleDialog = false;
    },
    confirmAdmin() {
      if (!this.adminPassword) {
        Toast.fail('请输入管理员密码');
        return;
      }
      if (this.adminPassword !== 'admin123') {
        Toast.fail('管理员密码错误');
        return;
      }
      this.role = 'admin';
      this.isAdmin = true;
      this.showRoleDialog = false;
      this.adminPassword = '';
      this.showAdminInput = false;
    },
    cancelAdmin() {
      this.adminPassword = '';
      this.showAdminInput = false;
    },
    // handleQsTextClick() {
    //   // 清除之前的计时器
    //   if (this.clickTimer) {
    //     clearTimeout(this.clickTimer);
    //   }
    //
    //   // 增加点击计数
    //   this.clickCount++;
    //
    //   // 如果连续点击3次，触发清除缓存
    //   if (this.clickCount >= 3) {
    //     this.clickCount = 0;
    //     this.clearRoomCache();
    //     return;
    //   }
    //
    //   // 设置3秒后重置计数（用户需要在3秒内点击3次）
    //   this.clickTimer = setTimeout(() => {
    //     this.clickCount = 0;
    //     this.clickTimer = null;
    //   }, 3000);
    // },
    clearRoomCache() {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        Toast.fail('连接尚未建立');
        return;
      }
      const msg = {
        type: 'control',
        controlType: 'CLEAR_CACHE',
        clientId: this.clientId,
      };
      this.ws.send(JSON.stringify(msg));
      // 清除前端生成的二维码和相关状态
      this.imageUrl = '';
      this.qrCreatedAt = null;
      this.qrCountdown = 0;
      this.qrValid = false;
      if (this.qrTimer) {
        clearInterval(this.qrTimer);
        this.qrTimer = null;
      }
      Toast.success('清除当前房间二维码');
    },
    toggleLockScreen() {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        Toast.fail('连接尚未建立');
        return;
      }
      const msg = {
        type: 'control',
        controlType: this.screenLocked ? 'UNLOCK' : 'LOCK',
        clientId: this.clientId,
      };
      this.ws.send(JSON.stringify(msg));
    },
    sendBroadcast() {
      if (!this.broadcastInput) {
        Toast.fail('请输入要广播的内容');
        return;
      }
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        Toast.fail('连接尚未建立');
        return;
      }
      const msg = {
        type: 'control',
        controlType: 'BROADCAST',
        clientId: this.clientId,
        message: this.broadcastInput,
      };
      this.ws.send(JSON.stringify(msg));
      this.broadcastInput = '';
    },

    async getPxInfo(keyScrent) {
      this.loading = true;
      this.error = false;
      this.errorMessage = '';
      try {
        const response = await getShadRoomInfo(keyScrent, this.isShadowMode);
        // console.log('getRoomInfo response:', response);
        if (response.code === 403) {
          this.handleIpBlocked(response.msg);
          return false;
        }
        if (response.code === 500) {
          Toast.fail(response.msg);
          this.error = true;
          this.errorMessage = response.msg || '服务返回错误';
          return false;
        } if (response.code === 200) {
          this.details = response.data || {};
          this.error = false;
          this.errorMessage = '';
          // 是否需要认证，根据返回数据中的isAuthorized字段判断
          this.isAuthorized = response.data && response.data.isAuthor === '1';

          if (this.isShadowMode) {
            this.isAuthorized = false;
            this.showAuthDialog = false;
            this.authPassed = true;
            this.showWatermark = false;
            this.connectWebSocket(false);
            return true;
          }

          if (this.isAuthorized) {
            // 需要认证，先检查本地存储的认证信息
            const authInfo = this.getAuthInfo();
            if (authInfo) {
              // 本地认证信息有效，自动提交认证
              this.authLoading = true;
              try {
                const authResponse = await verifyRoomAuth(
                  this.clientId,
                  authInfo.name,
                  authInfo.phone,
                );
                if (authResponse.code === 200) {
                  this.authPassed = true;
                  this.authName = authInfo.name;
                  this.authPhone = authInfo.phone;
                  this.showAuthDialog = false;
                  this.showWatermark = true;
                  this.watermarkText = `${authInfo.name}_${authInfo.phone}`;
                  Toast.success(`欢迎【${authInfo.name}】进入房间 ~`);
                  this.connectWebSocket(this.isAuthorized);
                } else {
                  // 本地存储的认证信息已失效，需要重新认证
                  this.showWatermark = false;
                  this.showAuthDialog = true;
                }
              } catch (e) {
                this.showWatermark = false;
                this.showAuthDialog = true;
              } finally {
                this.loading = false;
                this.authLoading = false;
                return true;
              }
            } else {
              // 没有本地认证信息，显示认证弹窗
              this.showWatermark = false;
              this.showAuthDialog = true;
              this.loading = false;
              return true;
            }
          }

          // 不需要认证，直接连接 WebSocket
          this.connectWebSocket(this.isAuthorized);
          if (this.isAuthorized && this.authPassed) {
            this.showWatermark = true;
            this.watermarkText = `${this.authName}_${this.authPhone}`;
          }
          return true;
        }
        this.error = true;
        this.errorMessage = response.msg || '未知错误';
        return false;
      } catch (err) {
        const errorMsg = '服务器错误';
        this.error = true;
        this.errorMessage = errorMsg;
        return false;
      } finally {
        this.loading = false;
      }
    },

    handleMessage(data) {

      // alert(data);
      try {
        const payload = typeof data === 'string' ? JSON.parse(data) : data;

        if (payload && payload.ipBlocked) {
          this.handleIpBlocked(payload.message);
          return;
        }

        // 移除对后端 imageUrl 的依赖，改为根据 pxUuID 生成二维码
        // if (payload.imageUrl) {
        //   this.imageUrl = payload.imageUrl;
        // }
        // 只有当onlineCount大于0时才更新，避免被推送的0值覆盖
        if (typeof payload.onlineCount === 'number') {
          this.onlineCount = payload.onlineCount;
        }

        if (Array.isArray(payload.users)) {
          this.onlinePersonnelList = payload.users.map(user => ({
            name: user.name || '',
            maskedPhone: user.maskedPhone || '',
            isInRoom: user.isInRoom === true || user.isInRoom === 'Y',
          }));
        }

        if (typeof payload.locked === 'boolean') {
          // this.screenLocked = payload.locked;
          if (payload.locked) {
          //  清除图片
            this.imageUrl = '';
            this.qrCountdown = 0;
            this.qrValid = false;
            this.qrCreatedAt = null;
          }
        }
        // 是否被移除
        if (typeof payload.remove === 'boolean') {
          // this.screenLocked = payload.locked;
          if (payload.remove) {
          //  清除图片
            this.imageUrl = '';
            //  设置被移除标志
            this.isRemoved = true;
            //  关闭 WebSocket 连接并清除重连计时器
            this.cleanupWebSocket();
            //  显示认证界面
            this.showWatermark = false;
            this.authPassed = false;
            this.showAuthDialog = true;
            Toast.fail(payload.removeMessage || '您已被移除房间！');
            return;
          }
        }
        if (payload.broadcastMessage) {
          this.roomNotifyText = payload.broadcastMessage;
          this.roomNotifyVisible = true;
          setTimeout(() => {
            this.roomNotifyVisible = false;
          }, 2000);
        }
        // 处理扫码次数，同时清除缓存以便下次查询获取最新数据
        if (typeof payload.signInCount === 'number') {
          this.signInCount = payload.signInCount;
          // 清除签到记录缓存
          if (this.details.keyScrent) {
            const cacheKey = `${this.details.keyScrent}_SIGN_IN`;
            delete this.scanLogCache[cacheKey];
          }
        }
        if (typeof payload.signOutCount === 'number') {
          this.signOutCount = payload.signOutCount;
          // 清除签退记录缓存
          if (this.details.keyScrent) {
            const cacheKey = `${this.details.keyScrent}_SIGN_OUT`;
            delete this.scanLogCache[cacheKey];
          }
        }
        // 只有消息明确携带 qsMessage 时才更新扫码提示；在线人数等普通推送不能清除红色状态。
        if (typeof payload.qsMessage === 'string' && payload.qsMessage.trim()) {
          let goText = payload.qsMessage;
          if (goText.startsWith('！！！')) {
            goText = goText.substring('！！！'.length).trim();
            this.isSpecialCondition = true; // 设置特殊条件标志
            this.vibrateReadyToScan();
            this.speakReadyToScan(goText);
          } else {
            this.isSpecialCondition = false; // 不以"！！！"开头，重置为蓝色背景
          }
          this.qsText = goText;
        }

        if (payload.pxUuID) {
          const sameQrCode = payload.pxUuID === this.qrUidRaw;
        // 根据 pxUuID 生成二维码（无论格式如何都生成）
          if (!sameQrCode) {
            this.generateQRCode(payload.pxUuID);
          }

          // 解析二维码生成时间戳（仅当格式为 d_xxx_timestamp_xxx 时才解析）
          if (!sameQrCode) {
            this.qrUidRaw = payload.pxUuID;
          }
          const parts = payload.pxUuID.split('_');

          if (parts.length >= 3) {
          // 特定格式：包含时间戳，解析并启动倒计时
            const ts = parseInt(parts[2]);
            if (!isNaN(ts)) {
              this.qrCreatedAt = ts;
              this.qrValid = true;
              const now = Date.now();
              const elapsed = Math.floor((now - ts) / 1000);
              // 使用 effectiveTime，如果未定义则使用默认的 qrTotalDuration
              const effectiveTime = this.details?.effectiveTime || this.qrTotalDuration;
              const left = effectiveTime - elapsed;
              if (left > 0) {
                this.qrCountdown = left;
                if (!sameQrCode) {
                  this.startDynamicQrVoice(left);
                  this.setupQrCountdown();
                } else if (!this.qrTimer) {
                  this.setupQrCountdown();
                }
              } else {
                this.qrCountdown = 0;
                this.qrValid = false;
                if (!sameQrCode) {
                  this.speakVoice('二维码已失效', false, { rate: 1.7 });
                }
                this.stopDynamicQrVoice();
                this.qsText = '二维码已过期';
              // 客户端倒计时结束，只更新显示状态，等待服务器统一清除通知
              // 不主动发送清除请求，避免因网络延迟导致不同步
              }
            } else {
            // 格式看起来像特定格式，但时间戳无效，当作普通字符串处理
              this.qrCreatedAt = null;
              this.qrCountdown = null;
              this.qrValid = true; // 普通字符串格式的二维码始终有效
              // 清除之前的倒计时
              if (this.qrTimer) {
                clearInterval(this.qrTimer);
                this.qrTimer = null;
              }
              this.stopDynamicQrVoice();
            }
          } else {
          // 普通字符串格式（如 "555asasasa"），不解析时间戳，不启动倒计时
            this.qrCreatedAt = null;
            this.qrCountdown = null;
            this.qrValid = true; // 普通字符串格式的二维码始终有效
            // 清除之前的倒计时
            if (this.qrTimer) {
              clearInterval(this.qrTimer);
              this.qrTimer = null;
            }
            this.stopDynamicQrVoice();
          }
        } else {
        // 如果没有 pxUuID，清除二维码
          this.imageUrl = '';
          this.qrCreatedAt = null;
          this.qrCountdown = null;
          this.qrValid = false;
          if (this.qrTimer) {
            clearInterval(this.qrTimer);
            this.qrTimer = null;
          }
          this.stopDynamicQrVoice();
        }
      } catch (e) {
        // 解析失败时忽略
        console.error('处理消息失败:', e);
      }
    },

    // 根据 pxUuID 生成二维码
    async generateQRCode(pxUuID) {
      if (this.ipBlocked) {
        return;
      }
      try {
        // 使用 QRCode.toDataURL 生成二维码图片（base64格式）
        const qrCodeDataUrl = await QRCode.toDataURL(pxUuID, {
          width: 400,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF',
          },
        });
        if (!this.ipBlocked) {
          this.imageUrl = qrCodeDataUrl;
        }
      } catch (error) {
        console.error('生成二维码失败:', error);
        Toast.fail('生成二维码失败');
        this.imageUrl = '';
      }
    },

    // 设置二维码倒计时
    setupQrCountdown() {
      if (this.qrTimer) {
        clearInterval(this.qrTimer);
      }
      this.qrTimer = setInterval(() => {
        if (!this.qrCreatedAt) {
          clearInterval(this.qrTimer);
          return;
        }
        const now = Date.now();
        const elapsed = Math.floor((now - this.qrCreatedAt) / 1000);
        // 使用 effectiveTime，如果未定义则使用默认的 qrTotalDuration
        const effectiveTime = this.details?.effectiveTime || this.qrTotalDuration;
        const left = effectiveTime - elapsed;
        if (left > 0) {
          this.qrCountdown = left;
          this.qrValid = true;
          this.handleQrVoiceCountdown(left);
        } else {
          this.qrCountdown = 0;
          this.qrValid = false;
          clearInterval(this.qrTimer);
          this.speakVoice('二维码已失效', false, { rate: 1.7 });
          this.stopDynamicQrVoice();
          this.qsText = '二维码已过期';
          // 客户端倒计时结束，只更新显示状态，等待服务器统一清除通知
          // 不主动发送清除请求，避免因网络延迟导致不同步
        }
      }, 1000);
    },

    scheduleReconnect(immediate = false) {
      if (this.ipBlocked || this.reconnectTimer || this.isRemoved || this.showAuthDialog) {
        return;
      }
      if (this.reconnectAttempts >= this.maxReconnectAttempts) {
        this.websocketStatus = {
          ready: false,
          state: 'danger',
          label: '连接失败',
          message: '重连次数已达上限，请刷新页面重试',
        };
        return;
      }
      const delay = immediate ? 0 : Math.min(this.reconnectDelay * (2 ** this.reconnectAttempts), this.maxReconnectDelay);
      this.reconnectAttempts += 1;
      this.reconnectTimer = setTimeout(() => {
        this.reconnectTimer = null;
        this.connectWebSocket(this.isAuthorized);
      }, delay);
    },
    cleanupWebSocket() {
      if (this.ws) {
        try {
          this.ws.onopen = null;
          this.ws.onmessage = null;
          this.ws.onerror = null;
          this.ws.onclose = null;
          this.ws.close();
        } catch (e) {}
        this.ws = null;
      }
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },

    getOrCreateVisitToken() {
      const storageKey = 'px_qr_visit_token';
      try {
        let token = window.sessionStorage.getItem(storageKey);
        if (!token) {
          token = `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
          window.sessionStorage.setItem(storageKey, token);
        }
        return token;
      } catch (e) {
        return `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
      }
    },

    handleIpBlocked(message) {
      this.ipBlocked = true;
      this.accessDeniedMessage = message || '当前网络已被限制访问培训房间。';
      this.imageUrl = '';
      this.qrUidRaw = '';
      this.qrCreatedAt = null;
      this.qrValid = false;
      this.qrCountdown = null;
      this.suppressReconnect = true;
      this.showAuthDialog = false;
      this.showVoicePrompt = false;
      this.showGuide = false;
      this.showScanLogPopup = false;
      this.showWatermark = false;
      if (this.qrTimer) {
        clearInterval(this.qrTimer);
        this.qrTimer = null;
      }
      this.cancelVoiceCountdown();
      this.stopHeartbeat();
      this.stopWebSocketHealthCheck();
      this.cleanupWebSocket();
      this.websocketStatus = {
        ready: false,
        state: 'danger',
        label: '访问受限',
        message: this.accessDeniedMessage,
      };
      this.loading = false;
      this.error = false;
    },

    // 提交认证信息
    handleAuthSubmit() {
      if (this.$refs.authFormRef) {
        this.$refs.authFormRef.validate().then(() => {
          this.submitAuth();
        }).catch(() => {});
      } else {
        this.submitAuth();
      }
    },
    async submitAuth() {
      this.authLoading = true;
      try {
        const name = String(this.authName || '').trim();
        const phone = String(this.authPhone || '').trim();

        if (!name) {
          Toast.fail('请输入姓名');
          return;
        }
        if (!phone) {
          Toast.fail('请输入手机号');
          return;
        }
        if (!/^1[3-9]\d{9}$/.test(phone)) {
          Toast.fail('手机号格式不正确');
          return;
        }

        const response = await verifyRoomAuth(
          this.clientId,
          name,
          phone,
        );

        if (response.code === 200) {
          // 被旧会话替换或管理员移除后，重新认证成功即可建立一个新的唯一会话。
          this.isRemoved = false;
          this.authPassed = true;
          this.authName = name;
          this.authPhone = phone;
          this.showWatermark = true;
          this.watermarkText = `${name}_${phone}`;
          this.showAuthDialog = false;
          this.saveAuthInfo(name, phone);
          Toast.success('验证成功');
          this.connectWebSocket(this.isAuthorized);
        } else if (response.code === 500) {
          Toast.fail(response.msg || '验证失败，请检查输入信息');
        } else {
          Toast.fail('验证失败，请稍后重试');
        }
      } catch (err) {
        const msg = err?.response?.data?.msg
          || err?.response?.data?.message
          || err?.message
          || '验证失败，请稍后重试';
        Toast.fail(msg);
      } finally {
        this.authLoading = false;
      }
    },

    async handleCardHover(e, scanType) {
      if (!this.details.keyScrent) return;

      this.popupType = scanType;
      const rect = e.currentTarget.getBoundingClientRect();
      this.popupPosition = {
        x: rect.left + rect.width / 2,
        y: rect.bottom + 8,
      };

      const cacheKey = `${this.details.keyScrent}_${scanType}`;
      if (this.scanLogCache[cacheKey]) {
        this.scanLogList = this.scanLogCache[cacheKey];
        this.showScanLogPopup = true;
        return;
      }

      this.scanLogLoading = true;
      try {
        const response = await getScanLogByKeyScrent(this.details.keyScrent, scanType);
        if (response.code === 200) {
          this.scanLogList = response.data || [];
          this.scanLogCache[cacheKey] = this.scanLogList;
        }
      } catch (err) {
        console.error('获取扫码记录失败', err);
      } finally {
        this.scanLogLoading = false;
        this.showScanLogPopup = true;
      }
    },

    handleCardLeave() {
      setTimeout(() => {
        if (!document.querySelector('.scan-log-popup:hover')) {
          this.showScanLogPopup = false;
        }
      }, 200);
    },

    handlePopupLeave() {
      this.showScanLogPopup = false;
    },

    formatScanTime(timeStr) {
      if (!timeStr) return '--';
      const date = new Date(timeStr);
      if (isNaN(date.getTime())) return timeStr;
      return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
    },

    formatIpRegion(region) {
      if (!region) return '中国';
      const parts = region.split('-');
      if (parts.length >= 3) {
        const city = parts[2];
        if (city && city.length > 0 && !['移动', '电信', '联通', 'CN', ''].includes(city)) {
          return city;
        }
      }
      if (parts.length >= 2) {
        const province = parts[1];
        if (province && province.length > 0 && !['移动', '电信', '联通', 'CN', ''].includes(province)) {
          return province;
        }
      }
      return '中国';
    },

    getPopupTitle() {
      return this.popupType === 'SIGN_IN' ? '签到记录' : '签退记录';
    },
  },
};
</script>

<style scoped>
.error-container {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #f8f9fa;
}

.qrcode-page--blocked {
  padding: 0;
}

.qrcode-page--blocked .error-container {
  flex: 1;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
}

.error-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 450px;
  width: 100%;
  animation: fadeInUp 0.6s ease-out;
}

.error-icon {
  font-size: 72px;
  color: #ff4d4f;
  margin-bottom: 24px;
  opacity: 0.9;
}

.error-content h3 {
  color: #262626;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}

.error-content p {
  color: #8c8c8c;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.refresh-btn-wrapper {
  margin-top: 20px;
}

.refresh-btn {
  padding: 10px 28px;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.refresh-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.2);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.qrcode-page {
  min-height: 100vh;
  padding: 24px 20px 32px;
  background: linear-gradient(135deg, #f9fafb 0%, #eef2f7 100%);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.qrcode-page.qrcode-page--offline {
  background: linear-gradient(135deg, #f4f6f8 0%, #e5e7eb 100%);
}
.loading-box{
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.qrcode-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
  padding-right: 96px;
}

.title-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gradient-pulse-text {
    /* 渐变文字颜色 */
    background: linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #f5576c 75%, #b8cbb8 100%);
    background-size: 200% auto;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font-weight: 600;

    /* 文字动画 */
    animation: gradient-flow 4s linear infinite;
    position: relative;
    padding-bottom: 8px;
}

.gradient-pulse-text::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0;
    left: 0;
    background: linear-gradient(90deg,
        transparent,
        #667eea,
        #764ba2,
        #f093fb,
        #f5576c,
        transparent);
    animation: pulse-line 2s infinite;
    border-radius: 3px;
}

@keyframes gradient-flow {
    0% { background-position: 0% center; }
    100% { background-position: 200% center; }
}

@keyframes pulse-line {
    0% {
        transform: scaleX(0);
        opacity: 0;
    }
    50% {
        transform: scaleX(1);
        opacity: 1;
    }
    100% {
        transform: scaleX(0);
        opacity: 0;
    }
}
.title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #1f2933;
}

.subtitle {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

.subtitle--strong {
  color: #d20000ad;
  font-weight: 700;
}

.subtitle-group--dual {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.subtitle--dual-compact {
  display: none;
}

.stats-container {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-item {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(31, 41, 55, 0.04);
  color: #374151;
  font-size: 13px;
}

.stat-item .dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  margin-right: 6px;
  background: #d1d5db;
}

.stat-item .dot.active {
  background: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.25);
}
.stat-item .dot.gctive {
  background: #b91056;
  box-shadow: 0 0 0 4px rgb(227 90 81 / 25%);
}
.stat-item .label {
  margin-right: 2px;
}

.stat-item .count {
  font-weight: 600;
}

.stat-item .unit {
  margin-left: 2px;
}

.notice-card {
  padding: 10px 14px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(209, 213, 219, 0.5);
}

.notice-title {
  margin: 0 0 6px 0;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.notice-list {
  margin: 0;
  padding-left: 14px;
  font-size: 12px;
  color: #6b7280;
}

.notice-list li {
  line-height: 1.5;
  margin-bottom: 3px;
}

.notice-list li:last-child {
  margin-bottom: 0;
}

.qrcode-content {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.qrcode-wrapper {
  width: 100%;
  max-width: 420px;
  aspect-ratio: 1 / 1;
  border-radius: 24px;
  background: radial-gradient(circle at top, #f3f4ff 0, #ffffff 40%, #f9fafb 100%);
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px;
  box-sizing: border-box;
}

.qrcode-wrapper--loading {
  background: radial-gradient(circle at top, #e5e7eb 0, #ffffff 40%, #f9fafb 100%);
}

.qrcode-wrapper--warning {
  border: 4px solid #ef4444;
  animation: qr-border-blink 0.5s ease-in-out infinite;
  box-shadow: 0 0 20px rgba(239, 68, 68, 0.4), 0 20px 40px rgba(15, 23, 42, 0.08);
}

@keyframes qr-border-blink {
  0%, 100% {
    border-color: #ef4444;
    box-shadow: 0 0 20px rgba(239, 68, 68, 0.4), 0 20px 40px rgba(15, 23, 42, 0.08);
  }
  50% {
    border-color: #ffffff;
    box-shadow: 0 0 30px rgba(239, 68, 68, 0.6), 0 20px 40px rgba(15, 23, 42, 0.08);
  }
}

.qrcode-image {
  max-width: 100%;
  max-height: 100%;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.16);
}

.qrcode-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.spinner {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: 3px solid rgba(156, 163, 175, 0.4);
  border-top-color: #4f46e5;
  animation: spin 0.8s linear infinite;
}

.placeholder-text {
  font-size: 13px;
  color: #6b7280;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.qs-text-display {
  margin: 18px auto 14px;
  padding: 16px 26px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  font-size: 19px;
  font-weight: 600;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.2);
  animation: pulse 2s infinite;
  width: min(92%, 760px);
  max-width: 100%;
  word-break: break-word;
}

.qs-text-display-red {
  background: linear-gradient(135deg, #ff0000, #cc0000);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

@media (max-width: 768px) {
  .qrcode-page {
    padding: 16px 12px 24px;
  }

  .qrcode-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-right: 0;
  }

  .security-tip-card {
    margin: 6px 10px 0;
    padding: 6px 8px;
  }

  .security-tip-track {
    display: block;
    width: 100%;
    animation: none;
  }

  .security-tip-card__text,
  .security-tip-card__text--clone {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    padding: 0;
    white-space: normal;
    text-align: center;
  }

  .security-tip-card__name {
    font-size: 14px;
    min-height: 20px;
    padding: 0 7px;
  }

  .security-tip-card__desc {
    font-size: 10px;
  }

  .security-tip-card__text--clone {
    display: none;
  }

  .qrcode-wrapper {
    max-width: 300px;
    border-radius: 20px;
  }

  .qs-text-display {
    font-size: 16px;
    padding: 10px 18px;
  }
}

.qs-text-display-offline {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  box-shadow: 0 8px 20px rgba(75, 85, 99, 0.18);
  border-color: rgba(255, 255, 255, 0.18);
  animation: none;
}

.network-float {
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 2200;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.10);
  border: 1px solid rgba(226, 232, 240, 0.9);
  font-size: 12px;
  font-weight: 700;
  color: #334155;
}

.network-float__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #94a3b8;
}

.network-float--success .network-float__dot { background: #22c55e; }
.network-float--warn .network-float__dot { background: #f59e0b; }
.network-float--danger .network-float__dot { background: #ef4444; }

.network-float--offline {
  top: 72px;
}

.network-float--danger,
.network-float--warn {
  color: #111827;
}

.qrcode-page.qrcode-page--offline .qrcode-header,
.qrcode-page.qrcode-page--offline .qrcode-container,
.qrcode-page.qrcode-page--offline .qrcode-content {
  filter: grayscale(1);
}

/* 认证弹窗样式 */
.auth-overlay {
  position: fixed;
  inset: 0;
  background:
    radial-gradient(circle at top, rgba(255,255,255,0.16), transparent 28%),
    linear-gradient(135deg, rgb(108 92 231 / 88%) 0%, rgb(0 184 148 / 60%) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 24px;
  backdrop-filter: blur(8px);
  touch-action: none;
  min-height: 100vh;
  min-height: 100dvh;
}

.auth-dialog {
  background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%);
  border-radius: 24px;
  width: 100%;
  max-width: 420px;
  padding: 28px 28px 24px;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.22);
  animation: authDialogSlide 0.28s cubic-bezier(.2,.8,.2,1);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@keyframes authDialogSlide {
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.auth-icon {
  width: 86px;
  height: 86px;
  background: linear-gradient(135deg, #667eea 0%, #7c3aed 100%);
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 18px;
  color: #fff;
  box-shadow: 0 14px 30px rgba(102, 126, 234, 0.24);
}

.auth-header {
  text-align: center;
  margin-bottom: 22px;
}

.auth-header h3 {
  font-size: 22px;
  font-weight: 800;
  color: #111827;
  margin: 0 0 8px 0;
  letter-spacing: 0.2px;
}

.auth-header p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.auth-scroll-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 2px 2px 12px;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.auth-field {
  background: #f8fafc;
  border-radius: 16px;
  box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.9);
}

.auth-field :deep(.van-field__label) {
  color: #374151;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.auth-field :deep(.van-field__value) {
  color: #111827;
}

.auth-submit-wrapper {
  margin-top: 12px;
}

.auth-footer {
  flex: 0 0 auto;
  padding-top: 6px;
}

.auth-submit-btn {
  height: 52px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 16px;
  margin-top: 0;
  background: linear-gradient(135deg, #667eea 0%, #7c3aed 100%);
  border: none;
  box-shadow: 0 10px 24px rgba(102, 126, 234, 0.30);
  transition: all 0.25s ease;
}

.auth-submit-btn:active {
  transform: translateY(1px) scale(0.99);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.22);
}

/* 移动端适配 */
@media (max-width: 480px) {
  .auth-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .auth-dialog {
    width: 100%;
    max-width: 100%;
    height: 90vh;
    height: 90dvh;
    padding: 14px 14px 10px;
    border-radius: 26px 26px 0 0;
    box-shadow: 0 -14px 40px rgba(15, 23, 42, 0.20);
  }

  .auth-icon {
    width: 62px;
    height: 62px;
    margin: 0 auto 12px;
    border-radius: 20px;
  }

  .auth-header {
    margin-bottom: 12px;
  }

  .auth-header h3 {
    font-size: 20px;
  }

  .auth-header p {
    font-size: 13px;
  }

  .auth-form {
    gap: 12px;
  }

  .auth-field :deep(.van-field__control) {
    font-size: 16px;
    padding: 10px 0;
  }

  .auth-submit-wrapper {
    margin-top: 8px;
  }

  .auth-footer {
    padding-top: 10px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    background: linear-gradient(180deg, rgba(255,255,255,0.72) 0%, rgba(255,255,255,0.98) 100%);
  }

  .auth-submit-btn {
    height: 48px;
  }
}

/* PC端适配 */
@media (min-width: 769px) {
  .auth-dialog {
    padding: 48px 40px 36px;
  }

  .auth-icon {
    width: 88px;
    height: 88px;
  }

  .auth-header h3 {
    font-size: 24px;
  }

  .auth-header p {
    font-size: 15px;
  }

  .auth-form {
    gap: 24px;
  }

  .auth-submit-btn {
    height: 54px;
    font-size: 17px;
  }

}

/* 连接状态卡片 */
.network-card {
  margin: 10px 16px 0;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.05);
  border: 1px solid rgba(226, 232, 240, 0.88);
}

.network-card--success {
  border-color: rgba(34, 197, 94, 0.14);
  box-shadow: 0 6px 14px rgba(34, 197, 94, 0.05);
}

.network-card--warn {
  border-color: rgba(245, 158, 11, 0.14);
  box-shadow: 0 6px 14px rgba(245, 158, 11, 0.05);
}

.network-card--danger {
  border-color: rgba(239, 68, 68, 0.14);
  box-shadow: 0 6px 14px rgba(239, 68, 68, 0.05);
}

.network-float {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 20;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.10);
  border: 1px solid rgba(226, 232, 240, 0.92);
}

.network-float__dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #94a3b8;
}

.network-float__text {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  letter-spacing: 0.2px;
}

.network-float--success {
  border-color: rgba(34, 197, 94, 0.20);
}

.network-float--success .network-float__dot {
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.12);
}

.network-float--success .network-float__text {
  color: #166534;
}

.network-float--warn {
  border-color: rgba(245, 158, 11, 0.20);
}

.network-float--warn .network-float__dot {
  background: #f59e0b;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.12);
}

.network-float--warn .network-float__text {
  color: #92400e;
}

.network-float--danger {
  border-color: rgba(239, 68, 68, 0.20);
}

.network-float--danger .network-float__dot {
  background: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.12);
}

.network-float--danger .network-float__text {
  color: #991b1b;
}

.voice-enable-bar {
  display: flex;
  justify-content: center;
  margin: 6px 0 10px;
}

.voice-enable-button {
  height: 34px;
  padding: 0 15px;
  border-radius: 999px;
  color: #64748b;
  background: rgba(255, 255, 255, 0.94);
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.voice-enable-button--active {
  color: #1677c8;
  background: linear-gradient(135deg, #f4faff 0%, #e8f4ff 100%);
  border-color: rgba(0, 148, 255, 0.32);
  box-shadow: 0 4px 12px rgba(0, 148, 255, 0.14);
}

.voice-enable-button__dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 6px;
  border-radius: 50%;
  background: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.16);
  vertical-align: middle;
}

.voice-enable-button__dot--active {
  background: #0094ff;
  box-shadow: 0 0 0 3px rgba(0, 148, 255, 0.14);
  animation: voice-status-pulse 1.8s ease-in-out infinite;
}

.voice-enable-button__state {
  font-weight: 600;
}

.voice-enable-button__action {
  margin-left: 7px;
  font-size: 11px;
  opacity: 0.78;
}

@keyframes voice-status-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.22);
  }
}

.voice-prompt-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.45);
  box-sizing: border-box;
}

.voice-prompt-dialog {
  width: min(360px, 100%);
  padding: 24px 22px 20px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.22);
  text-align: center;
  box-sizing: border-box;
}

.voice-prompt-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  border-radius: 50%;
  color: #0094ff;
  background: rgba(0, 148, 255, 0.1);
  font-size: 24px;
}

.voice-prompt-title {
  margin: 0 0 8px;
  color: #1f2937;
  font-size: 18px;
  font-weight: 700;
}

.voice-prompt-desc {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
}

.voice-prompt-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 20px;
}

.voice-prompt-actions .van-button {
  width: 100%;
  height: 36px;
  border-radius: 999px;
}

.security-tip-card {
  margin: 10px 16px 0;
  padding: 10px 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(254, 243, 199, 0.95) 0%, rgba(255, 247, 237, 0.95) 100%);
  border: 1px solid rgba(251, 191, 36, 0.35);
  box-shadow: 0 8px 20px rgba(251, 191, 36, 0.10);
  overflow: hidden;
}

.security-tip-track {
  display: flex;
  width: max-content;
  animation: security-tip-scroll 12s linear infinite;
}

.security-tip-card__text {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  font-size: 12px;
  line-height: 1.4;
  color: #7c2d12;
  font-weight: 600;
  padding-right: 28px;
}

.security-tip-card__text--clone {
  padding-left: 28px;
}

.security-tip-card__name {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 900;
  color: #92400e;
  background: rgba(251, 191, 36, 0.22);
  border: 1px solid rgba(251, 191, 36, 0.28);
  letter-spacing: 0.2px;
  line-height: 1;
}

.security-tip-card__desc {
  font-size: 12px;
  color: #7c2d12;
  font-weight: 600;
}

@keyframes security-tip-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* 房间通知浮动提示样式 */
.room-notify {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  border-radius: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  font-size: 14px;
  max-width: 90%;
  word-break: break-all;
}

.room-notify-text {
  flex: 1;
}

.room-notify-fade-enter-active,
.room-notify-fade-leave-active {
  transition: all 0.3s ease;
}

.room-notify-fade-enter,
.room-notify-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

/* 二维码倒计时样式 */
.qr-countdown-box {
  margin-top: 16px;
  text-align: center;
  padding: 12px 20px;
}

.countdown-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  padding: 12px 24px;
  border-radius: 30px;
  border: 2px solid #86efac;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15);
  transition: all 0.3s ease;
}

.countdown-wrapper.countdown-warning {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fca5a5;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
  animation: pulse-warning 0.8s ease-in-out infinite;
}

@keyframes pulse-warning {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.02);
    opacity: 0.9;
  }
}

.countdown-label {
  font-size: 14px;
  color: #166534;
  font-weight: 500;
}

.countdown-warning .countdown-label {
  color: #991b1b;
}

.countdown-number {
  font-size: 32px;
  font-weight: 700;
  color: #16a34a;
  min-width: 48px;
  text-align: center;
  transition: all 0.3s ease;
}

.countdown-critical {
  color: #dc2626;
  animation: shake 0.5s ease-in-out infinite;
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-3px);
  }
  75% {
    transform: translateX(3px);
  }
}

.countdown-unit {
  font-size: 14px;
  color: #166534;
  font-weight: 500;
}

.countdown-warning .countdown-unit {
  color: #991b1b;
}

.countdown-expired {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  padding: 12px 24px;
  border-radius: 30px;
  border: 2px solid #fca5a5;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.15);
}

.expired-icon {
  font-size: 18px;
}

.expired-text {
  font-size: 14px;
  color: #dc2626;
  font-weight: 500;
}

/* 移动端适配 */
@media (max-width: 480px) {
  .qrcode-page {
    padding: 16px 12px 24px;
    /* min-height: calc(100vh - 44px); */
    box-sizing: border-box;
  }

  .qrcode-header {
    margin-bottom: 10px;
    position: relative;
  }

  .title {
    font-size: 18px;
  }

  .subtitle {
    font-size: 11px;
  }

  .notice-card {
    padding: 8px 12px;
    margin-bottom: 10px;
  }

  .notice-title {
    font-size: 12px;
    margin-bottom: 4px;
  }

  .notice-list {
    font-size: 11px;
    padding-left: 12px;
  }

  .notice-list li {
    line-height: 1.4;
    margin-bottom: 2px;
  }

  .admin-panel {
    margin-bottom: 8px;
  }

  .qrcode-container {
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
  }

  .qs-text-display {
    margin: 12px auto 10px;
    padding: 8px 12px;
    line-height: 1.35;
    font-size: 13px;
  }

  .qrcode-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    margin-top: 4px;
  }

  .qrcode-wrapper {
    max-width: 280px;
    padding: 8px;
    border-radius: 18px;
  }

  .qrcode-wrapper--warning {
    border-width: 3px;
  }

  .qrcode-image {
    border-radius: 12px;
  }

  .qr-countdown-box {
    margin-top: 6px;
    padding: 4px 12px 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .countdown-wrapper,
  .countdown-expired {
    padding: 7px 12px;
    border-radius: 18px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }

  .countdown-label,
  .countdown-unit,
  .expired-text {
    font-size: 11px;
  }

  .countdown-number {
    font-size: 22px;
    min-width: 36px;
  }

  .room-notify {
    top: 10px;
    padding: 10px 16px;
    font-size: 13px;
    border-radius: 20px;
    max-width: 85%;
  }
}
</style>

<style>
.security-tip-card.security-tip-card--dual {
  width: min(68%, 980px);
  background: transparent;
  background-image: none !important;
  border: none !important;
  box-shadow: none !important;
  overflow: visible !important;
  padding: 12px 14px;
  margin: 10px auto 0 !important;
  margin-left: auto;
  margin-right: auto;
}

.security-tip-card.security-tip-card--dual .dual-status-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
}

.security-tip-card.security-tip-card--dual .dual-status-card__meta {
  flex: 1 1 auto;
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
  padding: 4px 0;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  padding: 12px 14px;
  border-radius: 16px;
  position: relative;
  overflow: visible;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease, background-color 0.25s ease;
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  overflow: hidden;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  background: rgba(95, 148, 118, 0.12);
  pointer-events: none;
  box-sizing: border-box;
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress-bar {
  display: block;
  position: relative;
  height: 100%;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  background: linear-gradient(90deg, #8dc7a3 0%, #5f9476 100%);
  transition: width 0.3s ease-out;
  overflow: visible;
  will-change: width;
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress-gif {
  position: absolute;
  width: 32px;
  height: 32px;
  background: url('../../assets/imag/gg.gif') no-repeat center;
  background-size: contain;
  z-index: 999;
  pointer-events: none;
  top: -20px;
  transform: translateX(-50%);
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress-bar::before {
  content: '';
  position: absolute;
  top: 0;
  right: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 100%);
  animation: dual-progress-flow-right-to-left 3s ease-in-out infinite;
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress-bar::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  animation: dual-progress-glow 3s ease-in-out infinite;
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--warning {
  background: rgba(230, 191, 134, 0.14);
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--warning .dual-status-card__progress-bar {
  background: linear-gradient(90deg, #f0c78b 0%, #d79a4a 100%);
  box-shadow: 0 0 8px rgba(247, 199, 139, 0.5);
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--warning .dual-status-card__progress-gif {
  filter: drop-shadow(0 0 4px rgba(247, 199, 139, 0.6));
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--warning .dual-status-card__progress-bar::before {
  background: linear-gradient(270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0) 100%);
  animation: dual-progress-flow-right-to-left 2.5s ease-in-out infinite;
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--ending {
  background: rgba(229, 164, 164, 0.14);
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--ending .dual-status-card__progress-bar {
  background: linear-gradient(90deg, #efb0b0 0%, #d87979 100%);
  box-shadow: 0 0 6px rgba(239, 112, 112, 0.4);
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--ending .dual-status-card__progress-gif {
  filter: drop-shadow(0 0 4px rgba(239, 112, 112, 0.6));
  animation: dual-progress-gif-pulse 1.5s ease-in-out infinite;
}

@keyframes dual-progress-gif-pulse {
  0%, 100% {
    transform: translateX(50%) scale(1);
  }
  50% {
    transform: translateX(50%) scale(1.15);
  }
}

.security-tip-card.security-tip-card--dual .dual-status-card__progress.dual-status-card__code--ending .dual-status-card__progress-bar::before {
  background: linear-gradient(270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0) 100%);
  animation: dual-progress-flow-right-to-left 2s ease-in-out infinite;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.02em;
  position: relative;
}

.security-tip-card.security-tip-card--dual .dual-status-card__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  background: #ff4d4f;
  border-radius: 9px;
  margin-left: 4px;
  box-shadow: 0 2px 4px rgba(255, 77, 79, 0.3);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code-state {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 2px;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code-count {
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(0, 0, 0, 0.15);
  padding: 3px 10px;
  border-radius: 999px;
  margin-top: 4px;
}

.scan-log-popup {
  position: fixed;
  transform: translateX(-50%);
  z-index: 1000;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  min-width: 240px;
  max-width: 300px;
  max-height: 300px;
  overflow: hidden;
}

.scan-log-popup__arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
}

.scan-log-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: linear-gradient(135deg, #0094ff 0%, #00c6fb 100%);
  color: #fff;
}

.scan-log-popup__title {
  font-size: 14px;
  font-weight: 600;
}

.scan-log-popup__count {
  font-size: 12px;
  opacity: 0.9;
}

.scan-log-popup__body {
  padding: 8px;
}

.scan-log-popup__empty {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 13px;
}

.scan-log-popup__list {
  max-height: 220px;
  overflow-y: auto;
}

.scan-log-popup__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
}

.scan-log-popup__item:last-child {
  border-bottom: none;
}

.scan-log-popup__time {
  color: #333;
  font-weight: 500;
}

.scan-log-popup__region {
  color: #666;
  flex-shrink: 0;
  margin-left: 12px;
}

.scan-log-popup__remaining {
  color: #ff6b6b;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  margin-left: 8px;
  padding: 2px 6px;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 4px;
}

.security-tip-card.security-tip-card--dual .dual-status-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
}

.security-tip-card.security-tip-card--dual .dual-status-card__icon .van-icon {
  font-size: 11px;
  line-height: 1;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--soon {
  border: 1px solid rgba(226, 190, 138, 0.5);
  color: #8f6b42;
  background: linear-gradient(180deg, #fffdf9 0%, #fbf4ea 100%);
  box-shadow: 0 6px 18px rgba(212, 177, 126, 0.1);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--soon .dual-status-card__icon {
  background: rgba(255, 248, 238, 0.96);
  box-shadow: inset 0 0 0 1px rgba(212, 177, 126, 0.28);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--soon .dual-status-card__icon .van-icon {
  color: #b48755;
  animation: dual-status-gentle-pulse 1.9s ease-in-out infinite;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active {
  border: 1px solid rgba(152, 204, 176, 0.5);
  color: #47745f;
  background: linear-gradient(180deg, #fbfefc 0%, #edf8f1 100%);
  box-shadow: 0 8px 20px rgba(124, 176, 148, 0.14);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active.dual-status-card__code--healthy {
  border-color: rgba(152, 204, 176, 0.5);
  color: #47745f;
  background: linear-gradient(180deg, #fbfefc 0%, #edf8f1 100%);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active.dual-status-card__code--warning {
  border-color: rgba(230, 191, 134, 0.52);
  color: #91663d;
  background: linear-gradient(180deg, #fffdf8 0%, #fbf1e3 100%);
  box-shadow: 0 8px 20px rgba(214, 176, 121, 0.14);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active.dual-status-card__code--ending {
  border-color: rgba(229, 164, 164, 0.52);
  color: #9b5f5f;
  background: linear-gradient(180deg, #fffafa 0%, #faecec 100%);
  box-shadow: 0 8px 20px rgba(214, 156, 156, 0.14);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active .dual-status-card__icon {
  background: rgba(255, 255, 255, 0.92);
  box-shadow: inset 0 0 0 1px rgba(152, 204, 176, 0.28);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active .dual-status-card__icon .van-icon {
  color: #5f9476;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active.dual-status-card__code--warning .dual-status-card__icon {
  box-shadow: inset 0 0 0 1px rgba(230, 191, 134, 0.28);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active.dual-status-card__code--warning .dual-status-card__icon .van-icon {
  color: #b07a45;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active.dual-status-card__code--ending .dual-status-card__icon {
  box-shadow: inset 0 0 0 1px rgba(229, 164, 164, 0.28);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active.dual-status-card__code--ending .dual-status-card__icon .van-icon {
  color: #bf6f6f;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--idle {
  border: 1px solid rgba(205, 213, 225, 0.52);
  color: #8a97ab;
  background: linear-gradient(180deg, #fbfcfd 0%, #f3f6f9 100%);
  box-shadow: none;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--idle .dual-status-card__icon {
  background: rgba(255, 255, 255, 0.88);
  box-shadow: inset 0 0 0 1px rgba(203, 213, 225, 0.26);
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--idle .dual-status-card__icon .van-icon {
  color: #a3afc0;
}

.security-tip-card.security-tip-card--dual .dual-status-card__code--active .dual-status-card__icon .van-icon-clock-o {
  animation: rotating 1.8s linear infinite;
}

.security-tip-card.security-tip-card--dual .dual-status-card__countdown-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 12px;
  background: #f7f9fc;
  color: #5f6f86;
  border: 1px solid rgba(191, 201, 215, 0.42);
  border-radius: 999px;
  box-shadow: none;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
}

.security-tip-card.security-tip-card--dual .dual-status-card__countdown {
  display: flex;
  justify-content: flex-end;
  flex: 0 0 auto;
}

@keyframes dual-status-gentle-pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: inset 0 0 0 1px rgba(212, 177, 126, 0.28), 0 0 0 0 rgba(212, 177, 126, 0.08);
  }

  50% {
    transform: scale(1.08);
    box-shadow: inset 0 0 0 1px rgba(212, 177, 126, 0.28), 0 0 0 6px rgba(212, 177, 126, 0.04);
  }
}

@keyframes dual-progress-flow {
  0% {
    transform: translateX(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    transform: translateX(200%);
    opacity: 0;
  }
}

@keyframes dual-progress-flow-right-to-left {
  0% {
    transform: translateX(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.4;
  }
  100% {
    transform: translateX(-200%);
    opacity: 0;
  }
}

@keyframes dual-progress-glow {
  0%, 100% {
    opacity: 0.2;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.6;
    transform: translate(-50%, -50%) scale(1.2);
  }
}

@keyframes dual-progress-pulse {
  0%, 100% {
    opacity: 1;
    box-shadow: 0 0 8px rgba(239, 112, 112, 0.5);
  }
  50% {
    opacity: 0.8;
    box-shadow: 0 0 16px rgba(239, 112, 112, 0.8);
  }
}

@media (min-width: 769px) {
  .security-tip-card.security-tip-card--dual {
    min-width: 720px;
    max-width: 1040px;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 768px) {
  .title-block .subtitle-group.subtitle-group--dual {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .title-block .subtitle-group.subtitle-group--dual .subtitle--dual-full {
    display: none !important;
  }

  .title-block .subtitle-group.subtitle-group--dual .subtitle--dual-compact {
    display: inline-flex !important;
    align-items: center;
    font-size: 11px;
    line-height: 1.1;
  }

  .subtitle-group--dual {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .subtitle-group--dual .subtitle {
    font-size: 11px;
    line-height: 1.1;
  }

  .subtitle--dual-full {
    display: none;
  }

  .subtitle--dual-compact {
    display: inline-flex;
    align-items: center;
  }

  .security-tip-card.security-tip-card--dual {
    width: 85%;
    max-width: 280px;
    padding: 8px 10px;
    margin: 8px auto 0 !important;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card {
    flex-direction: column;
    gap: 6px;
    align-items: stretch;
    width: 100%;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__meta {
    width: 100%;
    flex: none;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    justify-content: center;
    align-items: stretch;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__code {
    width: 100%;
    min-width: 0;
    padding: 8px 10px;
    gap: 4px;
    box-sizing: border-box;
    border-radius: 10px;
    align-items: flex-start;
    text-align: left;
    overflow: visible;
    min-height: 60px;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__progress {
    height: 2px;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__code-title {
    width: 100%;
    min-height: 16px;
    justify-content: flex-start;
    font-size: 11px;
    line-height: 1.1;
    gap: 4px;
    position: relative;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 14px;
    height: 14px;
    padding: 0 4px;
    font-size: 9px;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    background: #ff4d4f;
    border-radius: 7px;
    margin-left: 2px;
    box-shadow: 0 1px 2px rgba(255, 77, 79, 0.3);
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__code-state {
    width: 100%;
    min-height: 14px;
    font-size: 10px;
    line-height: 1.1;
    text-align: left;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__code-count {
    font-size: 9px;
    padding: 1px 6px;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__icon {
    width: 14px;
    height: 14px;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__icon .van-icon {
    font-size: 9px;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__progress-gif {
    width: 20px;
    height: 20px;
    top: -14px;
    transform: translateX(-50%);
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__countdown {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;
    margin-top: 1px;
  }

  .security-tip-card.security-tip-card--dual .dual-status-card__countdown-num {
    min-height: 22px;
    padding: 0 10px;
    font-size: 12px;
    font-weight: 700;
    color: #4f6482;
    border-color: rgba(136, 156, 190, 0.38);
    background: #f4f7fb;
    border-radius: 999px;
  }
}
</style>
